import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.css']
})
export class UserItemComponent implements OnInit {

  @Input() user: any;
  @Input() selectedUser: any;
  @Output() showUser = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onShowUser(user) {
    this.showUser.emit(user);
  }

}
